import React from "react";
import styled, { css } from "styled-components";
import { propStyling, tombac } from "../../../shared";
import { Container } from "./Container";
import { HoverAnimation } from "./HoverAnimation";
export const Addon = _ref => {
  let {
    children,
    hoverEffect = "none",
    hoverEffectDelay,
    ...stylingProps
  } = _ref;
  return /*#__PURE__*/React.createElement(HoverAnimation, {
    delay: hoverEffectDelay,
    variant: hoverEffect
  }, /*#__PURE__*/React.createElement(Content, stylingProps, children));
};
const Content = styled.span.withConfig({
  displayName: "Addon__Content"
})(["", ""], _ref2 => {
  var _hover, _disabled;
  let {
    theme: {
      components: {
        button: {
          current
        }
      }
    }
  } = _ref2;
  return css(["all:initial;color:", ";cursor:inherit;font-size:", ";transition:0.1s ease-out;transition-property:color,opacity;z-index:1;", ":hover &&{color:", ";}", ":disabled &&{color:", ";}", ""], tombac.parse(current.color), tombac.unit(current.fontSize), Container, tombac.parse((_hover = current.hover) === null || _hover === void 0 ? void 0 : _hover.color), Container, tombac.parse((_disabled = current.disabled) === null || _disabled === void 0 ? void 0 : _disabled.color), propStyling);
});
//# sourceMappingURL=Addon.js.map